module.exports = __webpack_public_path__ + "static/media/image-blue.81b6ebdf.svg";